import React, { PureComponent, ReactNode } from 'react'
import { ILandingLink } from '../../models'
import { LiteralsService } from '../../services'
import StyledNav from './styles'

interface IProps {
  links: ILandingLink[]
  language: string
}

interface IState {
  isOpen: boolean
}

export class LandingNavigation extends PureComponent<IProps, IState> {
  public state: IState = { isOpen: false }

  private container = React.createRef<HTMLElement>()

  private menuButton = React.createRef<HTMLButtonElement>()

  public componentDidMount() {
    document.addEventListener('mousedown', this.closeOnOutsideClick)
    document.addEventListener('keydown', this.closeOnEscape)
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.closeOnOutsideClick)
    document.removeEventListener('keydown', this.closeOnEscape)
  }

  private closeOnOutsideClick = (event: MouseEvent) => {
    if (this.state.isOpen && !this.container.current?.contains(event.target as Node)) this.setState({ isOpen: false })
  }

  private closeOnEscape = (event: KeyboardEvent) => {
    if (event.key !== 'Escape' || !this.state.isOpen) return

    this.setState({ isOpen: false })
    this.menuButton.current?.focus()
  }

  private toggleMenu = () => this.setState(previousState => ({ isOpen: !previousState.isOpen }))

  private closeMenu = () => this.setState({ isOpen: false })

  private renderLink = (link: ILandingLink): ReactNode => (
    <li key={ link.href }>
      <a href={ link.href } onClick={ this.closeMenu }>{ LiteralsService.get(link.labelKey, true) }</a>
    </li>
  )

  public render(): ReactNode {
    const { isOpen } = this.state

    return (
      <StyledNav ref={ this.container } aria-label={ LiteralsService.get('landingSections', true) }>
        <button
          ref={ this.menuButton }
          type="button"
          className="menu-button"
          aria-label={ LiteralsService.get('menu', true) }
          aria-expanded={ isOpen }
          aria-controls="landing-menu"
          onClick={ this.toggleMenu }
        >
          <span className="menu-bars" aria-hidden="true" />
        </button>
        <ul id="landing-menu" className={ isOpen ? 'open' : '' }>{ this.props.links.map(this.renderLink) }</ul>
      </StyledNav>
    )
  }
}
